import React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { formatDate, numberWithComma } from 'helpers/format'
import { TableListPage } from 'Components/common/Table'
import { DailyVolumeData } from 'Store/minirmx-dashboard/types'

type Props = {
  data: DailyVolumeData[]
}

const CompareRevenueReport: React.FunctionComponent<Props> = props => {
  const { data } = props
  const renderTitle = (title: string, sub?: string) => {
    return (
      <div>
        <div>{title}</div>
        {sub && <div>{sub}</div>}
      </div>
    )
  }

  const columns = [
    {
      title: renderTitle('วันที่', ''),
      dataIndex: 'vol_dt',
      key: 'vol_dt',
      align: 'center',
      render: (val: string) => formatDate(val),
    },
    {
      title: renderTitle('ยอดขายสินค้า', 'ปัจจุบัน'),
      dataIndex: 'cur_vol',
      key: 'cur_vol',
      align: 'center',
      render: (val: number) => numberWithComma(val || 0),
    },
    {
      title: renderTitle('ยอดขายสินค้า', 'ปีที่ผ่านมา'),
      dataIndex: 'last_vol',
      key: 'last_vol',
      align: 'center',
      render: (val: number) => numberWithComma(val || 0),
    },
    {
      title: renderTitle('ผลต่างของยอดขายสินค้า', ''),
      dataIndex: 'diff_vol',
      key: 'diff_vol',
      align: 'center',
      render: (val: number) => numberWithComma(val || 0),
    },
  ]

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Row gutter={[16, 16]} justify="space-between" align="middle">
          <Col>
            <BoxTitle>รายงานเปรียบเทียบยอดขายรายวัน</BoxTitle>
          </Col>
        </Row>
      </Col>
      <Col md={24} xs={24} sm={24}>
        <BoxWrapper>
          <Row gutter={[48, 48]} align="top" justify="center">
            <Col span={24}>
              <TableListPage
                columns={columns}
                datas={data}
                isLoading={false}
                paginationContent={null}
                size="small"
                bordered={false}
                rowKey="product_option_id"
                scrollX={500}
              />
            </Col>
          </Row>
        </BoxWrapper>
      </Col>
    </Row>
  )
}

const BoxWrapper = styled.div`
  padding: 0px 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 10px;
  border-color: transparent;
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

export default CompareRevenueReport
